const doc = [({"zh_cn":({"adminComponentHotelMail":({"arrangedInformationDescription":"当设施确认预订时，这将显示在电子邮件中。", "hotelMailTitle":"电子邮件设置", "informationTitle":"連絡事項"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;